<gl-base-modal (closeModal)="close()" class="contestModal">
  @if (translate.currentLang === 'en') {
    <img src="/assets/png/contest_goodloading_750_452_en.png" alt="Contest" class="bannerImage"
      (click)="openContestForm()" />
    <div class="buttonContainer">
      <button class="button" outline-button (click)="openContestForm()">{{ 'open' | translate }}</button>
    </div>
  }
  @if (translate.currentLang === 'pl') {
    <img src="/assets/png/contest_goodloading_750_450_pl.png" alt="Konkurs" class="bannerImage"
      (click)="openContestForm()" />
    <div class="buttonContainer">
      <button class="button" submit-button (click)="openContestForm()">{{ 'open' | translate }}</button>
    </div>
  }
</gl-base-modal>
